import { Component, OnInit, EventEmitter, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-contributor-filter',
  templateUrl: './contributor-filter.component.html',
  styleUrls: ['./contributor-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContributorFilterComponent),
      multi: true
    }
  ]
})
export class ContributorFilterComponent implements OnInit {
  autore: string;
  @Output() confirmNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() quitNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  confirm() {
    this.confirmNotify.emit({ q: { field: 'autore', value: this.autore, regex: true }, t: { k: 'AUTORE', v: this.autore, l: 'autore' } });
  }

  enter(e) {
    if (e) e.preventDefault();

    if (this.autore) {
      this.confirm()
    }
  }

  quit() {
    this.quitNotify.emit();
  }

  ngOnInit() {
  }

  private propagateChange = (_: any) => { };

  public writeValue(s: string) {
    this.autore = s;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/helpers/filters/contributor-filter/contributor-filter.component.ts